import { CSSProperties, useMemo } from "react";
import clsx from "clsx";
import { DevelopmentType } from "@gql/sites-api/graphql";
import { getDevelopmentTypeGradientClass } from "react-migration/domains/projects/util/getDevelopmentTypeGradientClass";

type ProjectHatchProps =
  | {
      size: "sm" | "md";
      loading: true;
      imageSrc?: never;
      developmentType?: never;
    }
  | {
      size: "sm" | "md";
      loading?: false;
      imageSrc?: string | null;
      developmentType: DevelopmentType[];
    };

export const ProjectHatch = ({ size, imageSrc, developmentType, loading }: ProjectHatchProps) => {
  const backgroundStyle = useMemo<CSSProperties>(() => {
    if (imageSrc) {
      return { backgroundImage: `url(${imageSrc})`, backgroundSize: "cover", backgroundPosition: "center" };
    }

    return {};
  }, [imageSrc]);

  return (
    <div
      className={clsx("rounded-sm border border-neutral-200", "shrink-0 grow-0", {
        "h-5 w-5": size === "sm",
        "h-10 w-10": size === "md",
        "bg-background-surface-neutral-subtle animate-pulse": loading,
        [getDevelopmentTypeGradientClass(developmentType?.at(0) as DevelopmentType)]: !loading && developmentType,
      })}
      style={backgroundStyle}
    />
  );
};
